import React from 'react'
import GenericReport from '../GenericReport'

const TreatmentsByDealerPage: React.FC = () => {
  return <GenericReport reportId={4} />
}

export default TreatmentsByDealerPage
